import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { MentorSessionBookingData } from '@edtech-ui/core/models/mentors-sessions/post-booking-session';
import { MentorService } from '@edtech-ui/core/services/mentor-management/mentor.service';
import { PaymentService } from '@edtech-ui/core/services/payment-management/payment.service';
import { delay, of } from 'rxjs';
import { formatTimeBasedOnTimezone } from '@edtech-ui/core/utils/date-time.util';

@Component({
	selector: 'app-mentor-review-confirm-dialog',
	standalone: true,
	imports: [CommonModule, MatProgressSpinnerModule],
	templateUrl: './mentor-review-confirm-dialog.component.html',
	styleUrl: './mentor-review-confirm-dialog.component.scss'
})
export class MentorReviewConfirmDialogComponent implements OnInit {

	razorPayId: string | null = null;
	bookingData!: MentorSessionBookingData | null;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<MentorReviewConfirmDialogComponent>,
		private router: Router,
		private _paymentService: PaymentService,
		private _mentorService: MentorService
	) { }

	ngOnInit(): void {
		this.showConfirmBookingData();
		of(true).pipe(delay(5000)).subscribe(() => {
			this.goToSessionPage();
		});
		this.razorPayId = this._paymentService.razorPayPaymentId.getValue();
	}

	close() {
		this.dialogRef.close();
	}

	goToSessionPage() {
		if (this.data?.fromMentorPage) {
			this.dialogRef.close(true);
		} else {
		this.router.navigate(['student-dashboard/my-sessions']);
		this.dialogRef.close(false);
		}
	}

	showConfirmBookingData() {
		this._mentorService.saveConfirmBookingData.subscribe(data => {
			if (data) {
				this.bookingData = data;
				if (!this.bookingData.display_time && this.bookingData.start_time) {
					this.bookingData.display_time = formatTimeBasedOnTimezone(this.bookingData.start_time);
				}
			}
		});
	}

}